// Esqueleto (DESIGN §5.14): recuo com sweep, no formato final, só depois de 300 ms.
// Sobre a parede, desenhe o painel real vazio e os esqueletos dentro dele.
import type { ReactNode } from "react";
import { cn } from "../lib/cn";
import { useAtraso } from "../lib/hooks";

/** Bloco de esqueleto. Dê a altura/largura do conteúdo real via className. */
export function Esqueleto({ className, sobreTinta }: { className?: string; sobreTinta?: boolean }) {
  return (
    <span
      aria-hidden
      className={cn("block rounded-celula", sobreTinta ? "bg-tinta-2" : "esqueleto", className)}
    />
  );
}

/** Linhas de texto em esqueleto. */
export function EsqueletoTexto({ linhas = 2, className }: { linhas?: number; className?: string }) {
  return (
    <span aria-hidden className={cn("flex flex-col gap-2", className)}>
      {Array.from({ length: linhas }, (_, i) => (
        <Esqueleto key={i} className={cn("h-4", i === linhas - 1 ? "w-2/3" : "w-full")} />
      ))}
    </span>
  );
}

/** Linha de lista em esqueleto (mesma altura da LinhaLista). */
export function EsqueletoLinha({ comAvatar = true }: { comAvatar?: boolean }) {
  return (
    <div aria-hidden className="flex min-h-14 items-center gap-3 px-4 py-3">
      {comAvatar && <Esqueleto className="size-10 rounded-full" />}
      <span className="flex flex-1 flex-col gap-2">
        <Esqueleto className="h-4 w-1/2" />
        <Esqueleto className="h-3 w-1/3" />
      </span>
    </div>
  );
}

/**
 * Região carregando: nada nos primeiros 300 ms, depois `esqueleto`.
 * `rotulo` é lido pelo leitor de tela ("Carregando seu placar").
 */
export function Carregando({
  carregando,
  rotulo = "Carregando",
  esqueleto,
  children,
}: {
  carregando: boolean;
  rotulo?: string;
  esqueleto: ReactNode;
  children?: ReactNode;
}) {
  const mostrar = useAtraso(carregando, 300);
  if (!carregando) return <>{children}</>;
  return (
    <div aria-busy="true">
      <span className="sr-only">{rotulo}</span>
      {mostrar ? esqueleto : null}
    </div>
  );
}
